/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityaspectbigfive3Inputs */



/**
* | output |
* | --- |
* | "Big Five" |
*
* @param {Personalityaspectbigfive3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityaspectbigfive3 = /** @type {((inputs?: Personalityaspectbigfive3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityaspectbigfive3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Big Five")
	if (locale === "es") return /** @type {LocalizedString} */ ("Big Five")
	return /** @type {LocalizedString} */ ("Big Five")
});
export { personalityaspectbigfive3 as "personalityAspectBigFive" }